import { useMemo } from "react";
import { useTheme } from "styled-components";
import { Icons } from "components";
import { TableLeaderboardStyled } from "./styled";


const TableLeaderboard = ({
  columns,
  data,
  expandedRowId,
  onToggleExpand,
  renderExpandedContent,
  expandLabel = "ดูอันดับ",
  emptyLabel = "ไม่มีข้อมูล",
}) => {
  const theme = useTheme();

  const gridColumnsWithExpand = useMemo(
    () =>
      [...columns.map((col) => col.gridWidth || "1fr"), "auto"].join(" "),
    [columns]
  );

  const getDescendantProp = (obj, desc) => {
    if (!desc) return undefined;
    var arr = desc.split(".");
    while (arr.length && (obj = obj[arr.shift()]));
    return obj;
  };


  const renderCell = (col, row) => {
    const value = getDescendantProp(row, col.field);
    if (col.render) {
      return col.render({ origin: row, value });
    }
    return value;
  };

  return (
    <TableLeaderboardStyled $gridColumns={gridColumnsWithExpand}>
      <div className="table_header_row">
        {columns.map((col) => (
          <div
            key={col.key}
            className={`table_header_cell ${col.headerClassName || ""}`}
            style={col.headerStyle}
          >
            {col.renderTitle ? col.renderTitle : col.title}
          </div>
        ))}
        <div className="table_header_cell" />
      </div>

      {data.length === 0 ? (
        <div className="empty_state">{emptyLabel}</div>
      ) : (
        data.map((row) => {
          const expanded = expandedRowId === row.id;
          const expandedContent = renderExpandedContent?.(row);

          return (
            <div key={row.id} className="table_row_block">
              <div
                className={`table_body_row ${expanded ? "is_expanded_parent" : ""}`}
              >
                {columns.map((col) => (
                  <div
                    key={col.key}
                    className={col.className || ""}
                    style={col.style}
                  >
                    {renderCell(col, row)}
                  </div>
                ))}
                <div
                  className="expand_trigger"
                  onClick={() => onToggleExpand(row.id)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      onToggleExpand(row.id);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  {expandLabel}
                  {expanded ? (
                    <Icons.ArrowUp2
                      width={14}
                      height={14}
                      color={theme.COLORS.PURPLE_1}
                    />
                  ) : (
                    <Icons.ArrowDown2
                      width={14}
                      height={14}
                      color={theme.COLORS.PURPLE_1}
                    />
                  )}
                </div>
              </div>

              {expanded && expandedContent && (
                <div className="expanded_section">{expandedContent}</div>
              )}
            </div>
          );
        })
      )}
    </TableLeaderboardStyled>
  );
};

export default TableLeaderboard;
